<template>
  <div class="graph-container">
    <canvas
      id="graph"
      ref="graph" />
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  props: {
    labels: {
      type: Array,
      require: true,
      default: Array
    },
    values: {
      type: Array,
      require: true,
      default: Array
    },
    bgColors: {
      type: Array,
      require: true,
      default: Array
    },
    hoverBgColors: {
      type: Array,
      require: true,
      default: Array
    },
    updateChart: {
      type: Boolean,
      require: true,
      default: false
    },
    type: {
      type: String,
      require: true,
      default: 'pie'
    }
  },
  watch: {
    updateChart (val) {
      if (val === true) {
        this.update()
      }
    }
  },
  mounted () {
    let context = this.$refs.graph.getContext('2d')

    let options = {
      responsive: true,
      maintainAspectRatio: false
    }

    let data = {
      labels: this.labels,
      datasets: [
        {
          data: this.values,
          backgroundColor: this.bgColors,
          hoverBackgroundColor: this.hoverBgColors
        }
      ]
    }

    this.pieChart = new Chart(context, {
      type: this.type,
      data: data,
      options: options,
      borderAlign: 'inner'
    })
  },
  beforeDestroy () {
    this.pieChart.destroy()
  },
  methods: {
    update () {
      this.pieChart.data.datasets[0].data = this.values
      this.pieChart.data.labels = this.labels
      this.pieChart.update({
        lazy: true
      })
    }
  }
}
</script>

<style scoped>
.graph-container {
  height: 300px;
}
</style>
